import type { WalletProvider } from '@dynamic-labs-sdk/client/core';

import type { EvmWalletProviderWithCustomViemClient } from '../../EvmWalletProviderWithCustomViemClient.types';

/** @not-instrumented */
export const isEvmWalletProviderWithCustomViemClient = (
  walletProvider: WalletProvider
): walletProvider is EvmWalletProviderWithCustomViemClient => {
  return 'createViemWalletClient' in walletProvider;
};
